import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CEProductCustomizationDrawerPdp from './CEProductCustomizationDrawerPdp.jsx';

const parseJSONAttribute = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.error('Failed to parse JSON attribute:', error);
    return null;
  }
};

const mountProductCustomizationDrawers = () => {
  const elements = document.querySelectorAll('.product-customization-drawer-pdp__react');
  if (!elements.length) {
    console.warn('No product customization drawer elements found');
    return;
  }
  elements.forEach((element) => {
    if (element.dataset.reactMounted === 'true') {
      return;
    }
    element.dataset.reactMounted = 'true';

    const product = parseJSONAttribute(element.getAttribute('data-product'));
    const selectedVariant = parseJSONAttribute(element.getAttribute('data-selected-variant'));

    const storeName = element.getAttribute('data-store-name') || 'product-customization-drawer';
    const watchStoreChangesAttr = element.getAttribute('data-watch-store-changes');
    const watchStoreChanges = watchStoreChangesAttr !== 'false';

    const language = element.getAttribute('data-language');
    const locale = element.getAttribute('data-locale');
    const country = element.getAttribute('data-country');
    const market = element.getAttribute('data-market');

    const productHandle = element.getAttribute('data-product-handle') || product?.handle || null;
    const productType = element.getAttribute('data-product-type') || undefined;
    const playerHandle = element.getAttribute('data-player-handle') || undefined;
    const competitionHandle = element.getAttribute('data-competition-handle') || undefined;
    const isShopByPlayer = element.getAttribute('data-is-shop-by-player') === 'true';

    const showProductImageAttr = element.getAttribute('data-show-product-image');
    const showProductImage = showProductImageAttr !== 'false';

    const isAlwaysVisibleAttr = element.getAttribute('data-is-always-visible');
    const isAlwaysVisible = isAlwaysVisibleAttr !== 'false';
    const displayAt = element.getAttribute('data-display-at') || 'mobile';
    const hideAddToCartButton = element.getAttribute('data-hide-add-to-cart-button') === 'true';

    const localization =
      locale || country || market
        ? {
            locale: locale ?? undefined,
            country: country ?? undefined,
            market: market ?? undefined,
          }
        : undefined;

    createRoot(element).render(
      <StrictMode>
        <CEProductCustomizationDrawerPdp
          product={product}
          selectedVariant={selectedVariant}
          storeName={storeName}
          watchStoreChanges={watchStoreChanges}
          language={language}
          locale={locale}
          country={country}
          market={market}
          localization={localization}
          productHandle={productHandle}
          productType={productType}
          playerHandle={playerHandle}
          competitionHandle={competitionHandle}
          showProductImage={showProductImage}
          isAlwaysVisible={isAlwaysVisible}
          displayAt={displayAt}
          hideAddToCartButton={hideAddToCartButton}
          isShopByPlayer={isShopByPlayer}
        />
      </StrictMode>,
    );
  });
};

mountProductCustomizationDrawers();
